import { LANG_ES } from "../constants";
import { isB2bUser } from "../_common/utils/getLang";


export function getLinksStudentNoSignedConditions({ headerOptions }) {
    const links = []

    links.push(headerOptions.optHome);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}

export function getLinksStudentIsOnSite({ studentMeta, headerOptions, lang }) {
    const links = []

    if (studentMeta.canvas_access) {
        links.push(headerOptions.optHome);
        links.push(headerOptions.notices);
        links.push(headerOptions.optAccesoCampus);    // <- Raro: No se mostrará en el menú sino en el header, pero se pasa así a las apps ios / android
        links.push(headerOptions.optSep);
    }
    if (!isB2bUser(studentMeta.shop_id)) {
        links.push(headerOptions.optHistorialMatriculas);
    }
    links.push(headerOptions.optAccesoCampusMenu);
    links.push(headerOptions.optDirEnvio);
    links.push(headerOptions.optSep);
    if (!studentMeta.hideJobsMenu && lang === LANG_ES) links.push(headerOptions.optJobs);
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}

export function getLinksDisableStudent ({ headerOptions }) {
    const links = []
    links.push(headerOptions.optShop);
    links.push(headerOptions.optCerrar);
    return links;
}

export function getLinksStudentEmpty({ studentMeta, headerOptions }) {
    const links = []

    links.push(headerOptions.optHome);
    links.push(headerOptions.notices)
    links.push({...headerOptions.optPedidos, disabled: !studentMeta.has_any_order});
    links.push(headerOptions.optSep);
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}

export function getLinksStudentNoValidated({ studentMeta, headerOptions }) {
    const links = [];

    if (studentMeta.has_whatsapp) links.push(headerOptions.notices);
    if (studentMeta.canvas_access) links.push(headerOptions.optAccesoCampus);
    links.push(headerOptions.optCompletaMatricula);
    links.push(headerOptions.informativeSessions);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optAccesoCampusMenu);
    if (!isB2bUser(studentMeta.shop_id)) {
        links.push(headerOptions.optHistorialMatriculas);
    }
    links.push(headerOptions.optDirEnvio);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}

// Es como NoValidated, excepto porque, en este estado, los alumnos ya deberían poder inscribirse a exámenes y/o clases
export function getLinksStudentNoTitle({ studentMeta, headerOptions, showPueCertificates, lang }) {
    const links = [];

    links.push(headerOptions.optHome);
    links.push(headerOptions.notices);
    if (studentMeta.canvas_access) links.push(headerOptions.optAccesoCampus);
    links.push(headerOptions.optCompletaMatricula);
    links.push(headerOptions.informativeSessions);
    if (studentMeta.has_formalized_expedient === true) links.push(headerOptions.optSecretary);
    links.push(headerOptions.optOnlinerArea)
    links.push(headerOptions.optSep);
    links.push(headerOptions.optAccesoCampusMenu);
    links.push(headerOptions.optClasesPresenciales);
    links.push(headerOptions.optExamenes);
    if (showPueCertificates && lang === LANG_ES) links.push(headerOptions.optCertificados);
    links.push(headerOptions.optExpediente);
    if (!isB2bUser(studentMeta.shop_id)) {
        links.push(headerOptions.optHistorialMatriculas);
    }
    links.push(headerOptions.optDirEnvio);
    links.push(headerOptions.optSep);
    if (!micuentaenv.HideJobsMenu && lang === LANG_ES) links.push(headerOptions.optJobs);
    headerOptions.optFct.forEach(link => links.push(link));
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}



export function getLinksStudentValidated({ studentMeta, headerOptions, showInviteFriend, showGift, showPueCertificates, lang }) {
    const links = [];

    if (showInviteFriend) links.push(headerOptions.inviteFriend);
    if (showGift) links.push(headerOptions.gift);

    if (studentMeta.canvas_access) {
        links.push(headerOptions.optHome);
        links.push(headerOptions.notices);
        links.push(headerOptions.optAccesoCampus);    // <- Raro: No se mostrará en el menú sino en el header, pero se pasa así a las apps ios / android
    }
    links.push(headerOptions.informativeSessions);
    if (studentMeta.has_formalized_expedient === true) links.push(headerOptions.optSecretary)
    links.push(headerOptions.optOnlinerArea)
    links.push(headerOptions.optSep);
    links.push(headerOptions.optAccesoCampusMenu);
    links.push(headerOptions.optClasesPresenciales);
    links.push(headerOptions.optExamenes);
    if (showPueCertificates && lang === LANG_ES) links.push(headerOptions.optCertificados);
    links.push(headerOptions.optExpediente);
    links.push(headerOptions.optCompletaMatricula);
    if (!isB2bUser(studentMeta.shop_id)) {
        links.push(headerOptions.optHistorialMatriculas);
    }
    links.push(headerOptions.optDirEnvio);
    links.push(headerOptions.optSep);
    if (!micuentaenv.HideJobsMenu && lang === LANG_ES) links.push(headerOptions.optJobs);
    headerOptions.optFct.forEach(link => links.push(link));
    links.push(headerOptions.optShop);
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links
}

export function getLinksStudentTrial({ studentMeta, headerOptions }) {
    const links = []

    links.push(headerOptions.optHome);
    links.push(headerOptions.notices);
    links.push(headerOptions.optAccesoCampusMenu);
    links.push(headerOptions.optExpediente);
    if (studentMeta.has_formalized_expedient === true) links.push(headerOptions.optSecretary)
    links.push(headerOptions.optOnlinerArea)
    links.push(headerOptions.optSep);
    links.push(headerOptions.optCerrar);

    return links;
}
